import { render, staticRenderFns } from "./ClienteDirecciones.vue?vue&type=template&id=4e2511c0&"
import script from "./ClienteDirecciones.vue?vue&type=script&lang=js&"
export * from "./ClienteDirecciones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports